import { randomUUID } from "node:crypto"
import { Lead } from "./Lead"

describe('Create Lead Entity', () => {
    it('Should be able to create a new lead', () => {
        const origin = Lead.create({
            name: 'Test',
            email: 'test@mail.com',
            phone: '11999009900',
            originId: randomUUID(),
            userId: randomUUID()
        })

        expect(origin).toBeTruthy()
    })
})